export const currencyFormat = currency => Number.parseFloat(currency).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');